import { render, staticRenderFns } from "./NavContent.vue?vue&type=template&id=7f8944c3&scoped=true"
import script from "./NavContent.vue?vue&type=script&lang=js"
export * from "./NavContent.vue?vue&type=script&lang=js"
import style0 from "./NavContent.vue?vue&type=style&index=0&id=7f8944c3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8944c3",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileImg: require('/skade-pwa/components/ui/atom/ProfileImg.vue').default,OnlineStatusIndicator: require('/skade-pwa/components/ui/atom/OnlineStatusIndicator.vue').default})
